<div class="contenedor bg-body-tertiary py-3 px-3">


<div class="container py-3">
  <div class="px-4 text-center">
    <h1 style="color: var(--primary-color)" class="display-5 ">¿En qué influye en</h1>
    <h4 style="color: var(--primary-color)" class="display-5 fw-bold ">las Organizaciones?</h4>
</div>
</div>

<div class="container px-4 py-3" id="featured-3">
  <div class="row g-4 py-5 row-cols-1 row-cols-lg-3">
    <div  class="feature col text-center">
      <div class="feature-icon w-50 d-inline-flex align-items-center  justify-content-center  ">
        <img ngSrc="./assets/img/enterprise/control.svg" class="" alt="" height="90" width="90">
      </div>
      <p class="text-secondary fs-5">Analiza y controla los posibles agentes de riesgo de organización.</p>
    </div>
    <div  class="feature col text-center">
      <div class="feature-icon w-50 d-inline-flex align-items-center  justify-content-center  ">
        <img ngSrc="../../../assets/img/enterprise/desempeno.svg" class="" alt="" height="90" width="90">
      </div>
      <p class="text-secondary fs-5">Mejora el desempeño de los empleados, a través de condiciones optimas de trabajo.</p>
    </div>
    <div  class="feature col text-center">
      <div class="feature-icon w-50 d-inline-flex align-items-center  justify-content-center  ">
        <img ngSrc="../../../assets/img/enterprise/lesiones.svg" class="" alt="" height="90" width="90">
      </div>
      <p class="text-secondary fs-5">Minimiza las lesiones derivadas del trabajo.</p>
    </div>

  </div>
  <div class="row   g-4 py-5 row-cols-1 row-cols-lg-2 w-75 mx-auto">
    <div  class="feature col text-center">
      <div class="feature-icon w-25 d-inline-flex align-items-center  justify-content-center  ">
        <img ngSrc="../../../assets/img/enterprise/preventivas.svg" class="" alt="" height="90" width="90">
      </div>
      <p class="text-secondary fs-5">Promueve acciones preventivas para un trabajo sano y seguro.</p>
    </div>
    <div  class="feature col text-center">
      <div class="feature-icon w-25 d-inline-flex align-items-center  justify-content-center  ">
        <img ngSrc="../../../assets/img/enterprise/ausentismo.svg" class="" alt="" height="90" width="90">
      </div>
      <p class="text-secondary fs-5">Reduce el ausentismo, producto de accidentes y enfermedades laborales.</p>
    </div>
  </div>
  </div>

</div>
